import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgHeadwear } from '../../api/models';

export type TABLE_TYPE = Table<BsgHeadwear>;

export const TABLE = 'bsgHeadwear';
const SCHEMA = 'bsgHeadwearId, sortId';

class BsgHeadwearDatabase implements DataRepository<BsgHeadwear> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgHeadwear | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgHeadwear, key: Key): Promise<BsgHeadwear> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgHeadwear[]): Promise<BsgHeadwear[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgHeadwear[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgHeadwearDB = new BsgHeadwearDatabase(db);
